import { login, logout,loginCheckCode, yzuenbaoLogin, yzuenbaoVerify, getYzuenbaoConfig as fetchYzuenbaoConfig } from "@/api/api";
import {loginPot, getipAddress} from "@/api/apiPot";
import { getNavbarData } from "../actions";
import { behaviorloginOut, behaviorlogin, } from '@/api/apiPot.js'
import { getToken, setToken, removeToken,getPotToken,setPotToken } from "@/utils/auth";
// import { behaviorpageAccess} from '@/api/apiPot.js'
const state = {
    potToken: getPotToken(),
    token: getToken(),
    id: window.sessionStorage.getItem("userId") || "", //用户ID
    userName: window.sessionStorage.getItem("userName") || "", // 用户名
    userAllData: window.sessionStorage.getItem("userInfo") ?
        JSON.parse(window.sessionStorage.getItem("userInfo")) : {}, //用户所有数据
    // 药尊宝配置
    yzuenbaoConfig: {
        yzunbao_login_status: 0, // 0:关闭 1:弹窗询问 2:直接跳转
        yzunbao_login_describe: '' // 弹窗描述内容
    }
};

const mutations = {
    SET_USER_INFO: (state, userInfo) => {
        state.userAllData = userInfo;

        state.id = "";
        state.userName = "";
        if (userInfo) {
            state.id = userInfo.user_id;
            state.userName = userInfo.user_name;
        }
    },
    SET_POT_TOKEN: (state, token) => {
        state.potToken = token;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.userName = name;
    },
    SET_YZUENBAO_CONFIG: (state, config) => {
        state.yzuenbaoConfig = config;
    }
};

const actions = {
    /**
     * 登录
     */
    login({ commit, dispatch }, userInfo) {
        return new Promise((resolve, reject) => {
            console.log('=== 开始华丰本系统登录流程 ===');
            console.log('调用接口: /register/login');
            console.log('登录参数:', userInfo);
            
            login(userInfo)
                .then(res => {
                    console.log('=== 华丰本系统登录成功 ===');
                    console.log('华丰登录响应:', res);
                    
                    const data = res.data;
                    setToken(data.token); //存储token
                    setUserInfo(commit, data.user); //存储用户信息
                    commit("SET_TOKEN", data.token);
                    // commit("SET_POT_TOKEN", data.token);
                    commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                    getipAddress({ipUrl:data.ipapi})
                    console.log('华丰用户数据:', data);
                    
                    // 定义继续华丰登录的函数（执行埋点相关逻辑）
                    const continueHuafengLogin = () => {
                        console.log('=== 继续华丰本系统登录流程（埋点逻辑）===');
                        console.log('调用埋点接口: /api/getToken');
                        
                        loginPot({name:data.user.uer_name})
                            .then(res => {
                                console.log('埋点token获取成功:', res);
                                const data2 = res.data;
                                commit("SET_POT_TOKEN", data2.token);
                                setPotToken(data2.token); //存储token
                                console.log('埋点Token存储成功:', getPotToken());
                                
                                if(data2.token){
                                  console.log('准备调用行为埋点接口: /api/behavior/login');
                                  setTimeout(() => {
                                    behaviorlogin({ 
                                        ip: localStorage.getItem('ipAddress'),
                                        login_device_name: localStorage.getItem('login_device_name'),
                                        login_device_id: localStorage.getItem('login_device_id'), 
                                        inlet_index: '登入',
                                        login_device:3 
                                    }).then(() => {
                                        console.log('行为埋点记录成功');
                                    });
                                  },1000)
                                }
                            })
                            .catch(error => {
                                console.log('埋点接口调用失败:',error);
                            });
                    };

                    // 根据药尊宝配置决定是否进行第三方验证
                    const yzConfig = state.yzuenbaoConfig;
                    console.log('当前药尊宝配置:', yzConfig);
                    
                    if (yzConfig.yzunbao_login_status == 0) {
                        // 配置为0：关闭药尊宝跳转，直接执行华丰登录流程
                        console.log('=== 药尊宝功能已关闭，继续华丰登录流程 ===');
                        continueHuafengLogin();
                        resolve(data);
                    } else {
                        // 配置为0或2：按Login.vue中的逻辑处理
                        console.log('=== 配置为0或2，由Login.vue处理后续流程 ===');
                        // 配置为1：在登录页询问，先执行埋点逻辑
                        console.log('=== 配置为登录页询问，执行埋点逻辑后返回 ===');
                        continueHuafengLogin();
                        resolve(data); // 直接resolve，让Login.vue处理询问逻辑
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    loginCode({ commit, dispatch }, sign) {
        return new Promise((resolve, reject) => {
            loginCheckCode({ sign: sign })
                .then(res => {
                    if (res.data.status==1) {
                        const data = res.data;
                        setToken(data.token); //存储token
                        setUserInfo(commit, data.user); //存储用户信息
                        commit("SET_TOKEN", data.token);
                        // commit("SET_POT_TOKEN", data.token);
                        commit("app/SET_INDEX_POP_STATE", 0, { root: true });
                        console.log('data----',data);
                        
                        // 定义继续华丰登录的函数
                        const continueHuafengLogin = () => {
                            loginPot({name:data.user.uer_name})
                                .then(res => {
                                    const data2 = res.data;
                                    commit("SET_POT_TOKEN", data2.token);
                                    setPotToken(data2.token); //存储token
                                    console.log('getPotToken1234',getPotToken());
                                    if(data2.token){
                                      setTimeout(() => {
                                        behaviorlogin({ ip: localStorage.getItem('ipAddress'),
                                              login_device_name: localStorage.getItem('login_device_name'),
                                              login_device_id: localStorage.getItem('login_device_id'),
                                              inlet_index: '登入',login_device:3 }).then(() => {
                                        });
                                      },1000)
                                    }
                                })
                                .catch(error => {
                                    console.log('error',error);
                                });
                        };

                        // 根据药尊宝配置决定是否进行第三方验证（二维码登录）
                        const yzConfig = state.yzuenbaoConfig;
                        console.log('二维码登录 - 当前药尊宝配置:', yzConfig);
                        
                        if (yzConfig.yzunbao_login_status == 0) {
                            // 配置为0：关闭药尊宝跳转，直接执行华丰登录流程
                            console.log('=== 二维码登录：药尊宝功能已关闭，继续华丰登录流程 ===');
                            continueHuafengLogin();
                            resolve(data);
                        } else {
                            // 配置为1或2：二维码登录无法支持Login.vue的倒计时弹窗，直接跳首页
                            console.log('=== 二维码登录：无法支持倒计时弹窗，直接跳转首页 ===');
                            continueHuafengLogin();
                            resolve(data);
                        }
                    } else if(res.data.status==2) {
                        reject( '二维码已过期，刷新页面后重试！')
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * 验证药尊宝第三方账户
     */
    verifyYzuenbao({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            // 首先尝试免密登录, address: userInfo.address
            const loginParams = {
                username: userInfo.username,
                channel: userInfo.channel
            };
            
            console.log('尝试药尊宝免密登录:', loginParams);
            yzuenbaoLogin(loginParams)
                .then(res => {
                    console.log('药尊宝免密登录结果:', res);
                    if (res.data && res.data.code == '000000') {
                        // 免密登录成功
                        resolve({
                            success: true,
                            token: res.data.content,
                            message: '药尊宝免密登录成功'
                        });
                    } else {
                        // 免密登录失败，尝试密码验证
                        console.log('免密登录失败，尝试密码验证');
                        const verifyParams = {
                            username: userInfo.username,
                            password: userInfo.password,
                            channel: userInfo.channel,
                            address: userInfo.address
                        };
                        
                        yzuenbaoVerify(verifyParams)
                            .then(verifyRes => {
                                console.log('药尊宝密码验证结果:', verifyRes);
                                if (verifyRes.data && verifyRes.data.code == '000000') {
                                    // 密码验证成功
                                    resolve({
                                        success: true,
                                        token: verifyRes.data.content,
                                        message: '药尊宝密码验证成功'
                                    });
                                } else {
                                    // 密码验证也失败
                                    reject({
                                        success: false,
                                        message: verifyRes.data ? verifyRes.data.message : '药尊宝验证失败'
                                    });
                                }
                            })
                            .catch(verifyError => {
                                console.error('药尊宝密码验证请求失败:', verifyError);
                                reject({
                                    success: false,
                                    message: '药尊宝密码验证请求失败'
                                });
                            });
                    }
                })
                .catch(loginError => {
                    console.error('药尊宝免密登录请求失败:', loginError);
                    // 免密登录请求失败，尝试密码验证
                    const verifyParams = {
                        username: userInfo.username,
                        password: userInfo.password,
                        channel: userInfo.channel,
                        address: userInfo.address
                    };
                    
                    yzuenbaoVerify(verifyParams)
                        .then(verifyRes => {
                            console.log('药尊宝密码验证结果:', verifyRes);
                            if (verifyRes.data && verifyRes.data.code == '000000') {
                                // 密码验证成功
                                resolve({
                                    success: true,
                                    token: verifyRes.data.content,
                                    message: '药尊宝密码验证成功'
                                });
                            } else {
                                // 密码验证也失败
                                reject({
                                    success: false,
                                    message: verifyRes.data ? verifyRes.data.message : '药尊宝验证失败'
                                });
                            }
                        })
                        .catch(verifyError => {
                            console.error('药尊宝密码验证请求失败:', verifyError);
                            reject({
                                success: false,
                                message: '药尊宝验证请求失败'
                            });
                        });
                });
        });
    },

    /**
     * 退出登录
     */
    logout({ commit }) {
        return new Promise(async resolve => {
            try {
                // await logout();
                commit("SET_TOKEN", "");
                commit("SET_USER_INFO", "");
                clearLocalUserInfo(); //删除本地用户信息
                behaviorloginOut({ leave_index: '退出登录' }).then(res => {
                    console.log(res);
                    commit("SET_POT_TOKEN", '');
                    setPotToken('');
                });

                resolve();
            } catch (error) {
                console.log(error);
            }
        });
    },

    /**
     * 移除token
     */
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_TOKEN", "");
            removeToken();
            resolve();
        });
    },
    /**更新用户所有信息 此方法会实时更新所有监听了用户信息变动的页面
     *  调用举例    this.$store.dispatch("user/setUserAllData", userInfo);
     *  尽量不直接去更新storage里的数据  更新storage刷新后才有效果  直接调用上述方法可在监听的数据中都生效
     */
    setUserAllData({ commit }, userInfo) {
        return new Promise(resolve => {
            setUserInfo(commit, userInfo); //更新用户信息
            resolve();
        });
    },

    /**
     * 检查用户在药尊宝是否存在账号（仅检查，不登录）
     */
    checkYzuenbaoAccount({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            console.log('=== 检查药尊宝账号是否存在 ===');
            console.log('检查参数:', userInfo);
            
            // 尝试免密登录来检查账号是否存在
            const loginParams = {
                username: userInfo.username,
                channel: 1, // PC端
                address: userInfo.address || window.localStorage.getItem('ipAddress') || ''
            };
            
            console.log('即将调用药尊宝登录API，参数:', loginParams);

            yzuenbaoLogin(loginParams)
                .then(res => {
                    console.log('药尊宝账号检查结果:', res);
                    if (res.data && res.data.code == '000000') {
                        // code == '000000' 说明账号存在
                        console.log('药尊宝账号存在 (code: 000000)');
                        resolve({
                            exists: true,
                            token: res.data.content
                        });
                    } else {
                        // code != '000000' 说明账号不存在
                        console.log('药尊宝账号不存在 (code:', res.data ? res.data.code : 'unknown', ')');
                        resolve({
                            exists: false
                        });
                    }
                })
                .catch(loginError => {
                    console.error('药尊宝账号检查请求失败:', loginError);
                    // 请求失败，认为账号不存在
                    resolve({
                        exists: false,
                        error: '检查失败'
                    });
                });
        });
    },

    /**
     * 获取药尊宝登录配置
     */
    getYzuenbaoConfig({ commit }) {
        return new Promise((resolve, reject) => {
            console.log('=== 获取药尊宝登录配置 ===');
            fetchYzuenbaoConfig()
                .then(res => {
                    console.log('药尊宝配置响应:', res);
                    if (res.data && res.code == 200) {
                        const config = res.data;
                        // 确保yzunbao_login_status转换为数字类型
                        const yzunbaoStatus = parseInt(config.yzunbao_login_status) || 0;
                        const yzunbaoDescribe = config.yzunbao_login_describe || '';
                        
                        const configData = {
                            yzunbao_login_status: yzunbaoStatus,
                            yzunbao_login_describe: yzunbaoDescribe,
							yzunbao_login_alert_title: config.yzunbao_login_alert_title,
							yzunbao_login_alert_confirm: config.yzunbao_login_alert_confirm,
							yzunbao_login_alert_cancel: config.yzunbao_login_alert_cancel
                        };
                        
                        commit('SET_YZUENBAO_CONFIG', configData);
                        console.log('药尊宝配置已更新 - 原始:', config);
                        console.log('药尊宝配置已更新 - 处理后:', configData);
                        resolve(configData);
                    } else {
                        console.log('药尊宝配置获取失败，使用默认配置');
                        resolve({ yzunbao_login_status: 0, yzunbao_login_describe: '' });
                    }
                })
                .catch(error => {
                    console.error('获取药尊宝配置失败:', error);
                    // 失败时使用默认配置（关闭状态）
                    commit('SET_YZUENBAO_CONFIG', {
                        yzunbao_login_status: 0,
                        yzunbao_login_describe: ''
                    });
                    resolve({ yzunbao_login_status: 0, yzunbao_login_describe: '' });
                });
        });
    },

    /**
     * 首页弹窗询问是否跳转药尊宝（高优先级版本）
     */
    showYzuenbaoDialogWithPriority({ state, dispatch }, userInfo) {
        return new Promise((resolve, reject) => {
            const config = state.yzuenbaoConfig;
            console.log('检查药尊宝弹窗配置（高优先级）:', config);
            
            if (config.yzunbao_login_status !== 1) {
                console.log('药尊宝配置不是弹窗模式，跳过显示');
                resolve(false);
                return;
            }

            // 使用Element UI的MessageBox进行确认，设置最高z-index
            import('element-ui').then(ElementUI => {
                const { MessageBox } = ElementUI;
                
                MessageBox.confirm(
                    config.yzunbao_login_describe || '检测到您在药尊宝平台也有账户，是否跳转到药尊宝平台？',
                    '药尊宝平台登录',
                    {
                        confirmButtonText: '确定跳转',
                        cancelButtonText: '继续使用华丰',
                        type: 'info',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showClose: true,
                        customClass: 'yzuenbao-dialog yzuenbao-priority-dialog',
                        center: true,
                        modal: true,
                        modalClass: 'yzuenbao-modal-overlay'
                    }
                ).then(() => {
                    // 用户确认跳转
                    console.log('=== 用户确认跳转药尊宝（高优先级） ===');
                    dispatch('verifyYzuenbao', userInfo).then(yzResult => {
                        if (yzResult && yzResult.success) {
                            const targetUrl = `https://gdhf.yzunbao.com/transition-page?t=${yzResult.token}`;
                            console.log('药尊宝验证成功，跳转到:', targetUrl);
                            window.location.href = targetUrl;
                            resolve(true);
                        } else {
                            console.log('药尊宝验证失败，留在华丰系统');
                            ElementUI.Message.warning('药尊宝平台验证失败，继续使用华丰系统');
                            resolve(false);
                        }
                    }).catch(error => {
                        console.error('药尊宝验证失败:', error);
                        ElementUI.Message.error('药尊宝平台连接失败，继续使用华丰系统');
                        resolve(false);
                    });
                }).catch(() => {
                    // 用户取消跳转
                    console.log('=== 用户取消跳转药尊宝（高优先级） ===');
                    resolve(false);
                });
            }).catch(error => {
                // Element UI 加载失败，使用原生confirm作为备用
                console.warn('Element UI 加载失败，使用原生确认框:', error);
                const confirmed = confirm(config.yzunbao_login_describe || '是否跳转到药尊宝平台？');
                
                if (confirmed) {
                    console.log('=== 用户确认跳转药尊宝（原生确认框，高优先级） ===');
                    dispatch('verifyYzuenbao', userInfo).then(yzResult => {
                        if (yzResult && yzResult.success) {
                            const targetUrl = `https://gdhf.yzunbao.com/transition-page?t=${yzResult.token}`;
                            window.location.href = targetUrl;
                            resolve(true);
                        } else {
                            console.log('药尊宝验证失败');
                            resolve(false);
                        }
                    }).catch(error => {
                        console.error('药尊宝验证失败:', error);
                        resolve(false);
                    });
                } else {
                    console.log('=== 用户取消跳转药尊宝（原生确认框，高优先级） ===');
                    resolve(false);
                }
            });
        });
    },

    /**
     * 首页弹窗询问是否跳转药尊宝（原版本，保留兼容性）
     */
    showYzuenbaoDialog({ state, dispatch }, userInfo) {
        return new Promise((resolve, reject) => {
            const config = state.yzuenbaoConfig;
            console.log('检查药尊宝弹窗配置:', config);
            
            if (config.yzunbao_login_status !== 1) {
                console.log('药尊宝配置不是弹窗模式，跳过显示');
                resolve(false);
                return;
            }

            // 使用Element UI的MessageBox进行确认
            import('element-ui').then(ElementUI => {
                const { MessageBox } = ElementUI;
                
                MessageBox.confirm(
                    config.yzunbao_login_describe || '检测到您在药尊宝平台也有账户，是否跳转到药尊宝平台？',
                    '药尊宝平台登录',
                    {
                        confirmButtonText: '确定跳转',
                        cancelButtonText: '继续使用华丰',
                        type: 'info',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showClose: true,
                        customClass: 'yzuenbao-dialog'
                    }
                ).then(() => {
                    // 用户确认跳转
                    console.log('=== 用户确认跳转药尊宝 ===');
                    dispatch('verifyYzuenbao', userInfo).then(yzResult => {
                        if (yzResult && yzResult.success) {
                            const targetUrl = `https://gdhf.yzunbao.com/transition-page?t=${yzResult.token}`;
                            console.log('药尊宝验证成功，跳转到:', targetUrl);
                            window.location.href = targetUrl;
                            resolve(true);
                        } else {
                            console.log('药尊宝验证失败，留在华丰系统');
                            ElementUI.Message.warning('药尊宝平台验证失败，继续使用华丰系统');
                            resolve(false);
                        }
                    }).catch(error => {
                        console.error('药尊宝验证失败:', error);
                        ElementUI.Message.error('药尊宝平台连接失败，继续使用华丰系统');
                        resolve(false);
                    });
                }).catch(() => {
                    // 用户取消跳转
                    console.log('=== 用户取消跳转药尊宝 ===');
                    resolve(false);
                });
            }).catch(error => {
                // Element UI 加载失败，使用原生confirm作为备用
                console.warn('Element UI 加载失败，使用原生确认框:', error);
                const confirmed = confirm(config.yzunbao_login_describe || '是否跳转到药尊宝平台？');
                
                if (confirmed) {
                    console.log('=== 用户确认跳转药尊宝（原生确认框） ===');
                    dispatch('verifyYzuenbao', userInfo).then(yzResult => {
                        if (yzResult && yzResult.success) {
                            const targetUrl = `https://gdhf.yzunbao.com/transition-page?t=${yzResult.token}`;
                            window.location.href = targetUrl;
                            resolve(true);
                        } else {
                            console.log('药尊宝验证失败');
                            resolve(false);
                        }
                    }).catch(error => {
                        console.error('药尊宝验证失败:', error);
                        resolve(false);
                    });
                } else {
                    console.log('=== 用户取消跳转药尊宝（原生确认框） ===');
                    resolve(false);
                }
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};

export const setUserInfo = (commit, userData) => {
    commit("SET_USER_INFO", userData); //设置用户数据
    setLocalUserInfo(userData); //存储用户信息
};

//清除本地数据
const clearLocalUserInfo = () => {
    removeToken();
    window.sessionStorage.removeItem("userInfo");
    window.sessionStorage.removeItem("userName");
    window.localStorage.removeItem("ipAddress");//退出登录清楚ip地址
    window.sessionStorage.clear();
};

//存储本地数据
const setLocalUserInfo = userData => {
    window.sessionStorage.setItem("userInfo", JSON.stringify(userData));
    window.sessionStorage.setItem("userName", userData.user_name);
    window.sessionStorage.setItem("userNameInfo", userData.name);
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js